module.exports = __webpack_public_path__ + "img/santuario.2971e4c5.jpg";